 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGH from '@/components/html/03_Copyrigh'
 import HTML02_TITLE_PA from '@/components/html/02_Title_Pa'
 import HTML04_DEDICATI from '@/components/html/04_Dedicati'
 import HTML05_CONTENTS from '@/components/html/05_Contents'
 import HTML06_LIST_OF from '@/components/html/06_List_of'
 import HTML07_NOTE_ON from '@/components/html/07_Note_on'
 import HTML08_ACKNOWLE from '@/components/html/08_Acknowle'
 import HTML09_INTRODUC from '@/components/html/09_Introduc'
 import HTML10_1_SOCRAT from '@/components/html/10_1_Socrat'
 import HTML15_2_NOAH_A from '@/components/html/15_2_Noah_a'
 import HTML20_3_MATTHE from '@/components/html/20_3_Matthe'
 import HTML24_4_GREEKS from '@/components/html/24_4_Greeks'
 import HTML28_5_MOSES from '@/components/html/28_5_Moses'
 import HTML29_EPILOGUE from '@/components/html/29_Epilogue'
 import HTMLNOTES from '@/components/html/Notes'
 import HTML30_WORKS_CI from '@/components/html/30_Works_Ci'
 import HTML31_INDEX from '@/components/html/31_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_Contents",
 			"name" : "html/05_Contents",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_List_of",
 			"name" : "html/06_List_of",
 			"component" : HTML06_LIST_OF
 		},
 		{
 			"path" : "/html/07_Note_on",
 			"name" : "html/07_Note_on",
 			"component" : HTML07_NOTE_ON
 		},
 		{
 			"path" : "/html/08_Acknowle",
 			"name" : "html/08_Acknowle",
 			"component" : HTML08_ACKNOWLE
 		},
 		{
 			"path" : "/html/09_Introduc",
 			"name" : "html/09_Introduc",
 			"component" : HTML09_INTRODUC
 		},
 		{
 			"path" : "/html/10_1_Socrat",
 			"name" : "html/10_1_Socrat",
 			"component" : HTML10_1_SOCRAT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js